export default __webpack_public_path__ + "static/media/wordpress.819024dd.png";